/**
 * Panier : tiroir latéral et page panier.
 * Chaque zone [data-cart-section] se re-rend via la Section Rendering API après un changement.
 */

/* Re-rend toutes les zones panier de la page */
async function renderCartSections() {
  const zones = [...document.querySelectorAll('[data-cart-section]')];
  if (!zones.length) return;
  const ids = zones.map((zone) => zone.dataset.cartSection).join(',');
  const sections = await fetch(`${window.theme.routes.root}?sections=${ids}`).then((r) => r.json());

  zones.forEach((zone) => {
    const html = sections[zone.dataset.cartSection];
    if (!html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-inner]');
    const current = zone.querySelector('[data-cart-inner]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  });
}

let renderTimer;
document.addEventListener('cart:updated', () => {
  clearTimeout(renderTimer);
  renderTimer = setTimeout(renderCartSections, 30);
});

/* Changements de quantité (boutons +/−, saisie, retirer) dans n'importe quelle zone panier */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-cart-section] [data-cart-qty]');
  if (!button) return;
  event.preventDefault();
  await updateLine(button, Number(button.dataset.line), Math.max(0, Number(button.dataset.cartQty)));
});

document.addEventListener('change', async (event) => {
  const input = event.target.closest('[data-cart-section] [data-cart-input]');
  if (input) {
    await updateLine(input, Number(input.dataset.line), Math.max(0, parseInt(input.value, 10) || 0));
    return;
  }
  const sample = event.target.closest('[data-sample-select], [data-cart-attribute]');
  if (sample) {
    const key = sample.dataset.sampleSelect || sample.dataset.cartAttribute;
    await fetch(`${window.theme.routes.cart}/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [key]: sample.value.trim() } }),
    });
    return;
  }
  const note = event.target.closest('[data-cart-note]');
  if (note) {
    fetch(`${window.theme.routes.cart}/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value }),
    });
  }
});

async function updateLine(element, line, quantity) {
  const zone = element.closest('[data-cart-section]');
  zone.classList.add('is-loading');
  try {
    await window.theme.cart.change(line, quantity);
    clearTimeout(renderTimer);
    await renderCartSections();
  } catch (error) {
    window.alert(error.message);
  } finally {
    zone.classList.remove('is-loading');
  }
}

/* ---------------------------------------------------------- Tiroir */
class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('.cart-drawer__panel');

    document.addEventListener('cart:added', () => this.open());

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-trigger]')) {
        event.preventDefault();
        this.open(event.target.closest('[data-cart-trigger]'));
      }
    });

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-close]')) this.close();
    });

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
      if (event.key === 'Tab') this.trapFocus(event);
    });
  }

  open(opener) {
    if (this.classList.contains('is-open')) return;
    this.opener = opener || document.activeElement;
    this.hidden = false;
    void this.offsetWidth; // force le rendu pour que la transition démarre
    this.classList.add('is-open');
    window.themeLockScroll?.(true);
    this.panel.focus({ preventScroll: true });
  }

  close() {
    if (!this.classList.contains('is-open')) return;
    this.classList.remove('is-open');
    window.themeLockScroll?.(false);
    setTimeout(() => (this.hidden = true), 550);
    this.opener?.focus?.({ preventScroll: true });
  }

  trapFocus(event) {
    const focusables = [...this.querySelectorAll('a[href], button:not([disabled]), input, textarea')].filter(
      (el) => el.offsetParent !== null
    );
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}
customElements.define('cart-drawer', CartDrawer);
